import { render, staticRenderFns } from "./buttonsCheckComponent.vue?vue&type=template&id=7b658051&"
import script from "./buttonsCheckComponent.vue?vue&type=script&lang=js&"
export * from "./buttonsCheckComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports